import * as React from 'react';
import { Typography } from '@mui/material';
import { MAX_AMOUNT } from '../../favouriteselection/search/Popular.constant';

import {
  StyledChip,
  StyledChipWrapper,
} from '../../favouriteselection/selectedOverview/SelectedFavourites.styled';
import CustomAccordion from '../../shared/accordion/CustomAccordion';
import ChipDisplay from '../../shared/chips/ChipDisplay';
import AllSelectedTeamsModal from '../../favouriteselection/selectedOverview/AllSelectedFavouritesModal';
import useSelectedFavourites from '../../../zustand/SelectedFavourites';

const Overview: React.FC = () => {
  const { selectedTeams, selectedCompetitions } = useSelectedFavourites();
  const [open, setOpen] = React.useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<boolean>(true);
  const selectedTeamsCount = selectedTeams.length;
  const selectedCompetitionsCount = selectedCompetitions.length;
  const displayedTeams =
    selectedTeamsCount >= MAX_AMOUNT
      ? selectedTeams.slice(0, MAX_AMOUNT)
      : selectedTeams;
  const notDisplayedTeamsCount =
    selectedTeamsCount > MAX_AMOUNT ? selectedTeamsCount - MAX_AMOUNT : 0;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const toggleExpand = () => setExpanded((prev) => !prev);

  const showSelected =
    selectedCompetitions.length > 0 || selectedTeams.length > 0;
  return (
    <>
      {showSelected ? (
        <>
          <CustomAccordion
            expanded={expanded}
            mainText={`Selected teams and competitions (${selectedTeamsCount}/${selectedCompetitionsCount})`}
            toggleExpand={toggleExpand}
            expandedContent={
              <>
                <Typography variant="caption">Teams</Typography>
                <ChipDisplay data={displayedTeams} />
                {selectedTeamsCount > MAX_AMOUNT && (
                  <StyledChipWrapper>
                    <StyledChip
                      onClick={handleOpen}
                      label={`and ${notDisplayedTeamsCount} more`}
                      variant="outlined"
                    />
                  </StyledChipWrapper>
                )}

                <Typography variant="caption">Competitions</Typography>
                {selectedCompetitionsCount > 0 ? (
                  <ChipDisplay data={selectedCompetitions} />
                ) : (
                  <Typography variant="subtitle2" color="text.disabled">
                    No competitions selected
                  </Typography>
                )}

                {open && (
                  <AllSelectedTeamsModal
                    open={open}
                    handleClose={handleClose}
                    handleOpen={handleOpen}
                    content={
                      <ChipDisplay
                        data={selectedTeams}
                        displayScrollable={false}
                      />
                    }
                  />
                )}
              </>
            }
          />
        </>
      ) : (
        <Typography>Please select at least one team or competition</Typography>
      )}
    </>
  );
};
export default Overview;
